import React,{useState,useEffect,useRef} from "react"
import { getNewCondidateQualificationList } from "../../../Redux/Actions/newJoinerAction";
import {addCandidateQualification,updateCandidateQualification} from '../../HR/onboarding/api/Calls'
import { useDispatch } from "react-redux";
const AddQualificationModel = ({edit,userID,setSelected}) =>{
    const dispatch = useDispatch()
    const cancelRef = useRef(null);
    const initialValues = {
      name: "",
      degree_name:"",
      subject:''
    };
const NumericValueState = {
    from_year:'',
    to_year:''
    }
    const ref = useRef();
const [values, setValues] = useState(initialValues);
const [Numeric, setNumeric] = useState(NumericValueState);
const [DegreeDoc,setDegreeDocValues] = useState('');


const handleChange =  (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
}
const handleCancel = () => {
    setSelected(null);
    setValues(initialValues);
    setNumeric(NumericValueState)
};

const handleNumericChange =(e) =>{
    const { name, value } = e.target;
    const re = /^[0-9]*[.,]?[0-9]*$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      setNumeric({...Numeric,[name]:value})
    }
 }
const handleDegreeDocChange =  (e) => {
setDegreeDocValues(e.target.files[0]);
};
useEffect(() =>{
    if(edit) setValues(edit)
},[edit,userID])
const handleSubmit = (e) =>{
    e.preventDefault();
    if(name ==='' || degree_name ==='' || subject ==='' || from_year ==='' || to_year ==='' || DegreeDoc ===''){
        return alert('All field is required !');
    }else{
        const formdata = new FormData();
        formdata.append('user_id',userID);
        formdata.append('qualification_name', name);
        formdata.append('from_year', from_year);
        formdata.append('to_year', to_year);
        formdata.append('degree_name', degree_name);
        formdata.append('subject', subject);
        formdata.append('document', DegreeDoc);
        formdata.append('created_by', userID);
        addCandidateQualification(formdata).then((res) =>{
            if (res.status) {
                setValues(initialValues)
                cancelRef.current.click();
                ref.current.value = "";
                dispatch(getNewCondidateQualificationList(userID));
                return alert(res.msg)
            }else{
                return alert(res.msg)
            }
        })
    }
}

const handleUpdateInfo = (e) =>{
    e.preventDefault();
    e.preventDefault();
    if(name ==='' || degree_name ==='' || subject ==='' || from_year ==='' || to_year ==='' || DegreeDoc ===''){
        return alert('All field is required !');
    }else{
        const formdata = new FormData();
        formdata.append('user_id',userID);
        formdata.append('qualification_name', name);
        formdata.append('from_year', from_year);
        formdata.append('to_year', to_year);
        formdata.append('degree_name', degree_name);
        formdata.append('subject', subject);
        formdata.append('document', DegreeDoc);
        formdata.append('updated_by', userID);
      updateCandidateQualification(formdata,edit.id).then((res) =>{
          if (res.status) {
              setValues(initialValues)
              cancelRef.current.click();
              dispatch(getNewCondidateQualificationList(userID));
              return alert(res.msg)
          }else{
              return alert(res.msg)
          }
      })
  }
}
const {name,degree_name,subject} =values;
const {from_year,to_year} = Numeric;
    return (
        <>
        <div className="modal fade" id="educationdetail" tabIndex={-1} aria-labelledby="educationModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="float-end btn_close" ref={cancelRef} onClick={handleCancel} data-bs-dismiss="modal" aria-label="Close">
                  <i className="icon icon-cross" />
                </button>
                <div className="dash_white_box_ttl text-center" id="educationModalLabel">{edit === null ? 'Add':'Edit'} Qualification Detail</div>
           
                  <div className="mb-2">
                    <label className="col-form-label">Educational Institutions Name <sup className="error_mgs">*</sup></label>
                    <input type="text" className="form-control" value={name} name="name" onChange={handleChange}/>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label className="col-form-label">From Year <sup className="error_mgs">*</sup></label>
                      <input type="text" className="form-control" value={from_year} name="from_year" onChange={handleNumericChange}/>
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">To Year <sup className="error_mgs">*</sup></label>
                      <input type="text" className="form-control" value={to_year}  name="to_year" onChange={handleNumericChange} />
                    </div>
                  </div>
                  <div className="mb-2">
                    <label className="col-form-label">Degree / Diploma Major Subjects <sup className="error_mgs">*</sup></label>
                    <input type="text" className="form-control" value={degree_name} name="degree_name" onChange={handleChange} />
                  </div>
                  <div className="mb-2">
                    <label className="col-form-label">Major Subjects <sup className="error_mgs">*</sup></label>
                    <input type="text" className="form-control" value={subject} name="subject" onChange={handleChange} />
                  </div>
                  <div className="mb-4">
                    <label className="col-form-label">Upload Document <sup className="error_mgs">*</sup></label>
                    <div className="form-input input-group">
                      <input type="file" ref={ref} name="degree_doc" className="form-control uploadbtn" onChange={handleDegreeDocChange} id="degree_doc" />
                    </div>
                  </div>
                <div className="modalfooter">
                  <button type="button" className="btn_6 float-end ml10" data-bs-dismiss="modal" ref={cancelRef} onClick={handleCancel}>Cancel</button>
                  <button type="button" className="btn_5 float-end " onClick={edit === null ? handleSubmit:handleUpdateInfo}>{edit === null ? 'Add':'Edit'}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
    )
}
export default AddQualificationModel